import React from 'react';

import './Header.css';



const Header = () => {
    return (
        <div>
            <div className="head">
                <h1 className="title" >TukiTalk</h1>
                <h6 class="subtitle">Communication is the key....</h6>
            </div>
        </div>
    );
};

export default Header;